import { Button, Card, Checkbox, Col, Divider, Flex, Row, Space, Spin } from "antd";
import { Footer } from "antd/es/layout/layout";
import { Input, InputForm, Select } from "components/form";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import { formatPhoneNumber, formatTelephoneNumber, requestRemoveDat } from "utils/formatter/formatCommon";
import schema from "../schemas/employeeInfoContactSchema";
import styles from "../styles/EmployeeForm.module.css";

function EmployeeInfoContactForm({
  initialValues = {},
  relationshipOptions = [],
  provinceOptionsTh = [],
  provinceOptionsEn = [],
  districtOptionsTh = [],
  districtOptionsEn = [],
  subDistrictOptionsTh = [],
  subDistrictOptionsEn = [],
  handleProviceChange = () => { },
  handleDistrictChange = () => { },
  registeredProvinceOptionsTh = [],
  registeredProvinceOptionsEn = [],
  registeredDistrictOptionsTh = [],
  registeredDistrictOptionsEn = [],
  registeredSubDistrictOptionsTh = [],
  registeredSubDistrictOptionsEn = [],
  handleRegisteredProviceChange = () => { },
  handleRegisteredDistrictChange = () => { },
  onSubmit = () => { },
  onCancel = () => { },
  isLoading = false
}) {
  const { t } = useTranslation();


  const validate = (values) => {
    const errors = {};
    const { telephoneNumber, mobileNumber, emergencyMobileNumber } = values;

    // Check telephoneNumber length
    if (telephoneNumber && requestRemoveDat(telephoneNumber).length !== 9) {
      errors.telephoneNumber = t("error.phone_not_to_nine");
    }

    // Check mobileNumber length
    if (mobileNumber && requestRemoveDat(mobileNumber).length !== 10) {
      errors.mobileNumber = t("error.moblie_not_to_ten");
    }

    if (emergencyMobileNumber && requestRemoveDat(emergencyMobileNumber).length !== 10) {
      errors.emergencyMobileNumber = t("error.moblie_not_to_ten");
    }

    return errors;
  }



  return (
    <Formik
      enableReinitialize
      initialValues={{ ...initialValues }}
      validationSchema={schema}
      validate={validate}
      onSubmit={(value) => {
        onSubmit({
          ...value,
          telephoneNumber: value?.telephoneNumber ? requestRemoveDat(value.telephoneNumber) : null,
          mobileNumber: value?.mobileNumber ? requestRemoveDat(value.mobileNumber) : null,
          emergencyMobileNumber: value?.emergencyMobileNumber ? requestRemoveDat(value.emergencyMobileNumber) : null,
        })
      }}
    >
      {({ values, setFieldValue, setTouched, touched, errors }) => {
        const onProviceChange = (val) => {
          handleProviceChange(val);
          setFieldValue("districtId", null);
          setFieldValue("subDistrictId", null);
          setFieldValue("zipCode", null);
          setTouched(
            {
              districtId: false,
              subDistrictId: false,
              zipCode: false,
            },
            false
          );
        };

        const onDistrictChange = (val) => {
          handleDistrictChange(val);
          setFieldValue("subDistrictId", null);
          setFieldValue("zipCode", null);
          setTouched(
            {
              subDistrictId: false,
              zipCode: false,
            },
            false
          );
        };

        const onSubDistrictChange = (val) => {
          setFieldValue("zipCode", val.zipCode || null);
          setTouched({ zipCode: false }, false);
        };

        const onRegisteredProviceChange = (val) => {
          handleRegisteredProviceChange(val);
          setFieldValue("registerDistrictId", null);
          setFieldValue("registerSubDistrictId", null);
          setFieldValue("registerZipCode", null);
          setTouched(
            {
              registerDistrictId: false,
              registerSubDistrictId: false,
              registerZipCode: false,
            },
            false
          );
        };

        const onRegisteredDistrictChange = (val) => {
          handleRegisteredDistrictChange(val);
          setFieldValue("registerSubDistrictId", null);
          setFieldValue("registerZipCode", null);
          setTouched(
            {
              registerSubDistrictId: false,
              registerZipCode: false,
            },
            false
          );
        };

        const onRegisteredSubDistrictChange = (val) => {
          setFieldValue("registerZipCode", val.zipCode || null);
          setTouched({ registerZipCode: false }, false);
        };

        const handleSameRegisterAddressChange = () => {
          values.sameRegisterAddress === "Y" ? setFieldValue("sameRegisterAddress", "N") : setFieldValue("sameRegisterAddress", "Y");
        };

        return (
          <Spin spinning={isLoading}>
            <Form>
              <Card>
                <Space style={{ width: "100%" }} size={24} direction="vertical">
                  <Space size={12} direction="vertical">
                    <span style={{ fontSize: "16px", fontWeight: "bold" }}>{t("contact-information-0")}</span>
                    <Row gutter={[24, 0]} style={{ rowGap: "16px" }}>
                      <Col span={8}>
                        <Input
                          required
                          name="email"
                          label={t("company-e-mail-username-0")}
                          placeholder={t("company-e-mail-username-0")}
                          size="large"
                        // disabled
                        />
                      </Col>
                      <Col span={8} >
                        <InputForm
                          name="telephoneNumber"
                          label={t("telephone-no")}
                          placeholder={t("telephone-no")}
                          size="large"
                          onChange={(value) => {
                            let formattedNumber = formatTelephoneNumber(value);

                            setFieldValue("telephoneNumber", formattedNumber);
                          }}
                          errors={errors}
                          touched={touched}
                        />
                      </Col>
                      <Col span={8} >
                        <Input
                          name="personalEmail"
                          label={t("personal-email-address")}
                          placeholder={t("personal-email-address")}
                          size="large"
                        />
                      </Col>
                      <Col span={8} >
                        <Input
                          required
                          name="mobileNumber"
                          label={t("mobile-no-0")}
                          placeholder={t("mobile-no-0")}
                          onChange={(value) => {
                            let formattedNumber = formatPhoneNumber(value);
                            setFieldValue("mobileNumber", formattedNumber);
                          }}
                          size="large"
                          errors={errors}
                          touched={touched}
                        />
                      </Col>
                      <Col span={8} >
                        <Input
                          name="lineId"
                          label={t("line-id")}
                          placeholder={t("line-id")}
                          size="large"
                        />
                      </Col>
                    </Row>
                  </Space>
                  <Divider className={styles.customDivider} />
                  <div>
                    <Flex vertical style={{ rowGap: "12px" }}>
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>{t("register-address-information")}</span>
                      <Row gutter={24} >
                        <Col span={8} >
                          <Input
                            required
                            name="registerAddress"
                            label={t("company_profile.label.address_th")}
                            placeholder={t('company_profile.label.address_detail_th_placeholder')}
                            size="large"
                          />
                        </Col>
                        <Col span={8} >
                          <Select
                            required
                            name="registerProvinceId"
                            label={t("address.province")}
                            placeholder={t('company_profile.label.please_select')}
                            size="large"
                            options={registeredProvinceOptionsTh}
                            onChange={(_, item) => {
                              onRegisteredProviceChange(item?.provinceCode)
                              if (values.sameRegisterAddress === "Y") {
                                setFieldValue("provinceId", item.provinceId)
                              }
                            }}
                          />
                        </Col>
                        <Col span={8} >
                          <Select
                            required
                            name="registerDistrictId"
                            label={t("address.district")}
                            placeholder={t('company_profile.label.please_select')}
                            size="large"
                            options={registeredDistrictOptionsTh}
                            onChange={(_, item) => {
                              onRegisteredDistrictChange(item?.districtCodeId)
                              if (values.sameRegisterAddress === "Y") {
                                setFieldValue("districtId", item.districtId)

                              }
                            }}
                          />
                        </Col>
                      </Row>
                      <Row gutter={24}>
                        <Col span={8} >
                          <Select
                            required
                            name="registerSubDistrictId"
                            label={t("address.subdistrict")}
                            placeholder={t('company_profile.label.please_select')}
                            size="large"
                            options={registeredSubDistrictOptionsTh}
                            onChange={(_, item) => {
                              onRegisteredSubDistrictChange(item);
                              if (values.sameRegisterAddress === "Y") {
                                setFieldValue("subDistrictId", item.subDistrictId)
                              }
                            }}
                          />
                        </Col>
                        <Col span={8} >
                          <Input
                            required
                            name="registerZipCode"
                            label={t("address.postal_code")}
                            placeholder={t('company_profile.label.please_select')}
                            size="large"
                            maxLength={5}
                            disabled
                          />
                        </Col>
                      </Row>
                      {/* <p
                      style={{

                        borderStyle: "dashed",
                        borderColor: "rgb(112, 200, 212)",
                        borderWidth: "thin",
                        paddingBottom: "5px",
                        marginTop: '10px '
                      }}
                    ></p> */}
                      <Row gutter={24}>
                        <Col span={8} >
                          <Input
                            required
                            name="registerAddressEn"
                            label={t("company_profile.label.address_en")}
                            placeholder={t('company_profile.label.address_detail_en_placeholder')}
                            size="large"
                          />
                        </Col>
                        <Col span={8} >
                          <Select
                            required
                            name="registerProvinceId"
                            label={t("address.province")}
                            placeholder={t('company_profile.label.please_select')}
                            size="large"
                            options={registeredProvinceOptionsEn}
                            onChange={(_, item) => {
                              onRegisteredProviceChange(item?.provinceCode)
                              if (values.sameRegisterAddress === "Y") {
                                setFieldValue("provinceId", item.provinceId)
                              }
                            }}
                          />
                        </Col>
                        <Col span={8} >
                          <Select
                            required
                            name="registerDistrictId"
                            label={t("address.district")}
                            placeholder={t('company_profile.label.please_select')}
                            size="large"
                            options={registeredDistrictOptionsEn}
                            onChange={(_, item) => {
                              onRegisteredDistrictChange(item?.districtCodeId)
                              if (values.sameRegisterAddress === "Y") {
                                setFieldValue("districtId", item.districtId)
                              }
                            }}
                          />
                        </Col>
                      </Row>

                      <Row gutter={24}>
                        <Col span={8}>
                          <Select
                            required
                            name="registerSubDistrictId"
                            label={t("address.subdistrict")}
                            placeholder={t('company_profile.label.please_select')}
                            size="large"
                            options={registeredSubDistrictOptionsEn}
                            onChange={(_, item) => {
                              onRegisteredSubDistrictChange(item);
                              if (values.sameRegisterAddress === "Y") {
                                setFieldValue("subDistrictId", item.subDistrictId)
                              }
                            }}
                          />
                        </Col>
                        <Col span={8}>
                          <Input
                            required
                            name="registerZipCode"
                            label={t("address.postal_code")}
                            placeholder={t('company_profile.label.please_select')}
                            size="large"
                            maxLength={5}
                            onChange={(_, item) => {
                              if (values.sameRegisterAddress === "Y") {
                                setFieldValue("zipCode", item.zipCode)
                              }
                            }}
                            disabled
                          />
                        </Col>
                      </Row>
                    </Flex>

                  </div>

                  <Divider className={styles.customDivider} />

                  <div>
                    <span style={{ fontSize: "16px", fontWeight: "bold" }}>{t("address-information")}</span>
                    <Flex vertical style={{ rowGap: "12px" }}>
                      <Row gutter={[24, 0]}>
                        <Col span={12}>
                          <Checkbox
                            checked={values.sameRegisterAddress === "Y"}
                            onChange={handleSameRegisterAddressChange}
                          >
                            {t("same-register-address")}
                          </Checkbox>
                        </Col>
                      </Row>
                      {(values.sameRegisterAddress === "N" || values.sameRegisterAddress === null) && <>
                        <Row gutter={[24, 0]}>
                          <Col span={8}>
                            <Input
                              required={true}
                              name="address"
                              label={t("company_profile.label.address_th")}
                              placeholder={t('company_profile.label.address_detail_th_placeholder')}
                              size="large"
                            />
                          </Col>
                          <Col span={8}>
                            <Select
                              required={true}
                              name="provinceId"
                              label={t("address.province")}
                              placeholder={t('company_profile.label.please_select')}
                              size="large"
                              options={provinceOptionsTh}
                              onChange={(_, item) => {
                                onProviceChange(item?.provinceCode)
                              }}
                            />
                          </Col>
                          <Col span={8}>
                            <Select
                              required={true}
                              name="districtId"
                              label={t("address.district")}
                              placeholder={t('company_profile.label.please_select')}
                              size="large"
                              options={districtOptionsTh}
                              onChange={(_, item) => {
                                onDistrictChange(item.districtCodeId)
                              }}
                            />
                          </Col>
                        </Row>
                        <Row gutter={[24, 0]}>
                          <Col span={8} >
                            <Select
                              required={true}
                              name="subDistrictId"
                              label={t("address.subdistrict")}
                              placeholder={t('company_profile.label.please_select')}
                              size="large"
                              options={subDistrictOptionsTh}
                              onChange={(_, item) => {
                                onSubDistrictChange(item);
                                console.log("item", item);
                              }} />
                          </Col>
                          <Col span={8} >
                            <Input
                              required={true}
                              name="zipCode"
                              label={t("address.postal_code")}
                              placeholder={t('company_profile.label.please_select')}
                              size="large"
                              maxLength={5}
                              disabled
                            />
                          </Col>
                        </Row>
                        {/* <p
                        style={{
                          borderStyle: "dashed",
                          borderColor: "rgb(234 236 240)",
                          borderWidth: "thin",
                        }}
                      ></p> */}
                        <Row gutter={[24, 0]}>
                          <Col span={8}>
                            <Input
                              required={true}
                              name="addressEn"
                              label={t("company_profile.label.address_en")}
                              placeholder={t('company_profile.label.address_detail_en_placeholder')}
                              size="large"
                            />
                          </Col>
                          <Col span={8}>
                            <Select
                              required={true}
                              name="provinceId"
                              label={t("address.province")}
                              placeholder={t('company_profile.label.please_select')}
                              size="large"
                              options={provinceOptionsEn}
                              onChange={(_, item) => {
                                onProviceChange(item?.provinceCode)
                              }}
                            />
                          </Col>
                          <Col span={8}>
                            <Select
                              required={true}
                              name="districtId"
                              label={t("address.district")}
                              placeholder={t('company_profile.label.please_select')}
                              size="large"
                              options={districtOptionsEn}
                              onChange={(_, item) => {
                                onDistrictChange(item.districtCodeId)
                              }}
                            />
                          </Col>
                        </Row>

                        <Row gutter={[24, 0]}>
                          <Col span={8}>
                            <Select
                              required={true}
                              name="subDistrictId"
                              label={t("address.subdistrict")}
                              placeholder={t('company_profile.label.please_select')}
                              size="large"
                              options={subDistrictOptionsEn}
                              onChange={(_, item) => {
                                onSubDistrictChange(item);
                              }}
                            />
                          </Col>
                          <Col span={8} >
                            <Input
                              required={true}
                              name="zipCode"
                              label={t("address.postal_code")}
                              placeholder={t('company_profile.label.please_select')}
                              size="large"
                              maxLength={5}
                              disabled
                            />
                          </Col>
                        </Row>
                      </>
                      }
                    </Flex>
                  </div>

                  <Divider className={styles.customDivider} />
                  <Space size={12} direction="vertical" style={{ width: "100%" }}>
                    <span style={{ fontSize: "16px", fontWeight: "bold" }}>{t("emergency-contacts-0")}</span>
                    {/* <Flex vertical style={{ rowGap: "12px" }}> */}
                    <Row gutter={[24, 0]} style={{ rowGap: "16px" }}>
                      <Col span={8} >
                        <Input
                          name="emergencyName"
                          label={t("name")}
                          placeholder={t("name")}
                          size="large"
                        />
                      </Col>
                      <Col span={8}>
                        <Input
                          name="emergencysurName"
                          label={t("surname")}
                          placeholder={t("surname")}
                          size="large"
                        />
                      </Col>
                      <Col span={8}>
                        <Select
                          name="relationshipId"
                          label={t("relationship")}
                          placeholder={t('company_profile.label.please_select')}
                          size="large"
                          options={relationshipOptions}
                        />
                      </Col>
                      <Col span={8} >
                        <InputForm
                          name="emergencyMobileNumber"
                          label={t("mobile-no")}
                          placeholder={t("mobile-no")}
                          size="large"
                          onChange={(value) => {
                            let formattedNumber = formatPhoneNumber(value);
                            setFieldValue("emergencyMobileNumber", formattedNumber);
                          }}
                          errors={errors}
                          touched={touched}
                        />
                      </Col>
                    </Row>
                  </Space>
                  {/* </Flex> */}
                </Space>
              </Card>

              <Footer style={{
                zIndex: 999,
                bottom: 2,
                position: 'sticky',
                backgroundColor: 'white',
                height: "max-content",
                placeContent: "center"
              }}>
                <Row justify="end" style={{ gap: "12px" }}>
                  <Button type="default" onClick={() => {
                    onCancel()
                  }} style={{ width: "100px", height: "44px", borderRadius: "8px", padding: "8px 16px" }}
                  >
                    {t("common.cancel").toUpperCase()}
                  </Button>
                  <Button type="primary" htmlType="submit" style={{ width: "100px", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}>
                    {t("common.submit").toUpperCase()}
                  </Button>
                </Row>
              </Footer>
            </Form>
          </Spin>
        );
      }}
    </Formik>

  );
}

export default EmployeeInfoContactForm;
